const useQuestionNavigation = ({
  questions,
  lastInputStepIndex,
  getAnswersMap,
  shouldShowStep,
  findNextVisibleQuestion,
  dispatch,
  setQuestionStep,
  setTyping,
  renderStepText,
  getTranslatedOptions,
  addAiMessage,
  completeQuestionFlow,
}) => {
  const goToStepById = (stepId, force = false) => {
    const stepIndex = questions.findIndex((step) => step.id === stepId)

    if (stepIndex !== -1) {
      askQuestion(stepIndex, force)
    }
  }

  const askQuestion = (index, force = false) => {
    const step = questions[index]

    if (!step) return

    const answersMap = getAnswersMap()

    if (!force && !shouldShowStep(step, answersMap)) {
      const nextVisible = findNextVisibleQuestion(index + 1, answersMap)

      if (nextVisible !== null) {
        askQuestion(nextVisible)
      } else {
        completeQuestionFlow()
      }

      return
    }

    dispatch(setQuestionStep(index))
    setTyping(true)

    setTimeout(() => {
      setTyping(false)

      const stepText = renderStepText(step, answersMap)

      if (stepText) {
        addAiMessage({
          text: stepText,
          stepId: step.id,
          stepType: step.type,
          options: getTranslatedOptions(step) || null,
        })
      }

      if (step.autoAdvance && step.id !== 'diagnosis') {
        setTimeout(() => {
          goToNextStep(step.id)
        }, 500)
      }
    }, 700)
  }

  const goToNextStep = (currentStepId) => {
    const currentIndex = questions.findIndex(
      (step) => step.id === currentStepId,
    )

    if (currentIndex === lastInputStepIndex) {
      completeQuestionFlow()
      return
    }

    const answersMap = getAnswersMap()

    const nextVisible = findNextVisibleQuestion(currentIndex + 1, answersMap)

    if (nextVisible !== null) {
      if (questions[nextVisible]?.type === 'result') {
        completeQuestionFlow()
        return
      }

      askQuestion(nextVisible)
    } else {
      completeQuestionFlow()
    }
  }

  return {
    goToStepById,
    askQuestion,
    goToNextStep,
  }
}

export default useQuestionNavigation
